import { render, staticRenderFns } from "./DropdownMultiselect.vue?vue&type=template&id=25a4818d&scoped=true&"
import script from "./DropdownMultiselect.vue?vue&type=script&lang=js&"
export * from "./DropdownMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMultiselect.vue?vue&type=style&index=0&id=25a4818d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4818d",
  null
  
)

export default component.exports